module.exports = __webpack_public_path__ + "img/노쇠한 고령자(Frail)_old.9ae2c228.png";